import { isErrorResult } from '@/components/assistant-ui/message-part-utils';
import type {
  AnyToolCallPart,
  ProgressStepStatus,
} from '@/components/assistant-ui/thread/trail-records';

export function findCurrentStepId(
  steps: readonly { id: string; status: ProgressStepStatus }[],
): string | undefined {
  return (
    steps.find(s => s.status === 'in-progress')?.id ??
    steps.find(s => s.status === 'awaiting-approval')?.id ??
    steps.find(s => s.status === 'failed')?.id
  );
}

/** `failed` covers the explicit `isError` flag and results `isErrorResult` recognises as content. */
export function classifyToolPart(part: AnyToolCallPart): ProgressStepStatus {
  // Approval-gated calls (server lane): a suspended approval is the user's turn, not active
  // work — without this branch every no-result tool renders as an in-progress spinner.
  if (part.approval) {
    if (part.approval.resolution) return 'cancelled';
    if (part.approval.approved === false) return 'cancelled';
    if (part.approval.approved === undefined) return 'awaiting-approval';
  }
  if (part.state === 'approval-requested') return 'awaiting-approval';
  if (part.state === 'output-denied') return 'cancelled';
  if (part.result === undefined) return 'in-progress';
  if (part.isError === true || isErrorResult(part.result)) return 'failed';
  return 'completed';
}
